export default __webpack_public_path__ + "static/media/StorageContainerMk2.64.9d572c23.png";